import type { ListRecipesQuery } from '@/types/api';

export const recipeKeys = {
  all: ['recipes'] as const,
  lists: () => [...recipeKeys.all, 'list'] as const,
  list: (params?: ListRecipesQuery) =>
    [...recipeKeys.lists(), params?.query ?? '', params?.page ?? 1, params?.limit ?? 50] as const,
  detail: (id: number) => [...recipeKeys.all, 'detail', id] as const,
};
